import { render, staticRenderFns } from "./TasksCrudForm.vue?vue&type=template&id=612dbf98&"
import script from "./TasksCrudForm.vue?vue&type=script&lang=js&"
export * from "./TasksCrudForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports